import { DateStringZod } from '@onr/schema'
import { z } from 'zod'

export const RegionsMilestonesFormZod = z.record(DateStringZod, z.string().nullable())

export type RegionsMilestonesFormData = z.infer<typeof RegionsMilestonesFormZod>
